import React from 'react';
import {BASE_URL} from "../../Config/SharedConfig";
import {useNavigate, useParams} from "react-router-dom";

import {Pagination,} from 'swiper/modules';
import {Swiper, SwiperSlide} from "swiper/react";
import "swiper/css";
import 'swiper/css/pagination';
import {useQuery} from "@tanstack/react-query";
import Agent from "../../Network/Agent";
import ToolBar from "../../Components/Elements/ToolBar";
import {addCommas} from "../../Components/Utils/utilities";


const Show = () => {

    const params = useParams()
    const productCode = params.arg
    const navigate = useNavigate()

    const {data: product, isLoading} = useQuery({
        queryKey: ['product', productCode],
        queryFn: async () => {
            try {
                const response = await Agent.Product.getProduct(productCode)
                return response.data.result.product;
            } catch (error) {
                console.error('Error fetching Product:', error);
                throw error;
            }
        }
    })

    if (isLoading) return (
        <div className='shimmer-container'>
            <div className='container'>
                <div className='row'>
                    <div className='col-12'>
                        <div className='square-box shimmer mt-48'/>
                    </div>
                    <div className='col-12'>
                        <div className='line-title shimmer mt-56'/>
                        <div className='line-paragraph shimmer mt-12'/>
                    </div>
                </div>
            </div>
        </div>
    )
    return(
        <>
            <ToolBar title={''} navigate={() => navigate(-1)} />

            <div className='square-box'>
                <Swiper
                    modules={[Pagination]}
                    pagination={{ clickable: true }}
                    slidesPerView={"1"}
                    simulateTouch={true}
                    dir={"rtl"}
                    className="swiper-custom-1">
                    {
                        product?.files?.map((file) => {
                            return(
                                <SwiperSlide key={file.code}>
                                    <div className={'img-cnt-filled '+(product?.isForShow ? '' : 'inactive')}>
                                        <img src={BASE_URL+file.internalPath} alt="product"/>
                                    </div>
                                </SwiperSlide>
                            )
                        })
                    }
                </Swiper>
            </div>

            <div className='container mt-20'>
                <div className='row'>
                    <div className='col-12'>
                        <div className='mobile-h4 cl-black'>
                            { product?.title }
                        </div>
                    </div>
                    <div className='col-12'>
                        <div className='mobile-body-1-regular cl-black mt-12'>
                            { product?.description }
                        </div>
                    </div>
                </div>
            </div>


            <div className='btn-fixed-bottom'>
                <div className='container'>
                    <div className='row'>
                        <div className='col-6'></div>
                        <div className='col-6'>
                            {
                                product?.isForShow &&
                                <div className='mobile-h5 cl-black text-start'>
                                    {addCommas(product?.price)}
                                    <span className='mobile-body-2-regular cl-black mr-8'>
                                                            تومان
                                                        </span>
                                </div>
                            }
                            {
                                !product?.isForShow &&
                                <div className='mobile-h5 cl-black text-start'>
                                    ناموجود
                                </div>
                            }
                        </div>
                    </div>
                </div>
            </div>

            <div className='scroll-fixer'></div>

        </>
    );
}


export default Show